import chroma from 'chroma-js';
const hexy = /^#[0-9a-f]{3,6}$/i;
const colorString = /^(?:#(?:[A-Fa-f0-9]{3}){1,2}|(?:rgb[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*(?:,(?![)])|(?=[)]))){3}|hsl[(]\s*0*(?:[12]?\d{1,2}|3(?:[0-5]\d|60))\s*(?:\s*,\s*0*(?:\d\d?(?:\.\d+)?\s*%|\.\d+\s*%|100(?:\.0*)?\s*%)){2}\s*|(?:rgba[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*,){3}|hsla[(]\s*0*(?:[12]?\d{1,2}|3(?:[0-5]\d|60))\s*(?:\s*,\s*0*(?:\d\d?(?:\.\d+)?\s*%|\.\d+\s*%|100(?:\.0*)?\s*%)){2}\s*,)\s*0*(?:\.\d+|1(?:\.0*)?)\s*)[)])$/;
function isColorString(str) {
    if (!str)
        return false;
    if (str === 'none')
        return false;
    return str.match(hexy) || str.match(colorString);
}
export function color(str) {
    return isColorString(str) ? chroma(str) : null;
}
export function extractKeyColor(element, key) {
    const items = Array.from(element.querySelectorAll(`[${key}]`));
    return items
        ?.map(el => ({
        key,
        element: el,
        color: color(el.getAttribute(key))
    }))
        .filter(item => item.color !== null);
}
export function getSvgColors(element) {
    return {
        fills: extractKeyColor(element, 'fill'),
        strokes: extractKeyColor(element, 'stroke'),
        stops: extractKeyColor(element, 'stop-color')
    };
}
